export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/overlays_screen_packs.c55e0d5.svg";